import qs from "querystringify";
import _ from "lodash";
import { loginTimeOut } from "../common/utils/history";
import FileSaver from "file-saver";

let DEFAULT_HEADERS = {
  "Content-Type": "application/json; charset=utf-8",
  Accept: "application/json; charset=utf-8",
  "Accept-Language": "vi",
};
console.log(process.env.REACT_APP_BASE_URL) // remove this after you've confirmed it is working

// const MULTIPART_FORM_HEADER = {
//   'Content-Type': 'multipart/form-data',
//   'Mime-Type': 'jpg|jpeg|png'
// }
//http://avis.itleadpro.vn:8890/api/
//http://avis.itleadpro.vn:8083/customers?filter=..
//http://avis.itleadpro.vn:8890/api/web/customers/filter
const baseUrl =process.env?.REACT_APP_BASE_URL || "https://aviscar.avisvietnam.com.vn/api/";
// const baseUrl = "http://54.179.24.29:8890/api/";
//http://192.168.0.186:8890

export function setAccessToken(token: string): void {
  DEFAULT_HEADERS = {
    ...DEFAULT_HEADERS,
    Authorization: `${token}`,
  };
}

export const StatusCodes = {
  SUCCESS: 200,
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  SERVER_INTERNAL_ERROR: 500,
};

export const api = {
  get: (endpoint: string, params: Object) => {
    const options = {
      method: "GET",
      headers: {
        ...DEFAULT_HEADERS,
      },
    };
    return fetch(baseUrl + endpoint + qs.stringify(params, true), options).then(
      (result) => {
        if (result.status === StatusCodes.UNAUTHORIZED) {
          return loginTimeOut(result);
        }
        return result.json();
      }
    );
  },

  post: (endpoint: string, params: Object) => {
    const options = {
      method: "POST",
      // mode: 'no-cors',
      body: JSON.stringify(params),
      headers: {
        ...DEFAULT_HEADERS,
      },
    };
    return fetch(baseUrl + endpoint, options).then((result) => {
      if (result.status === StatusCodes.UNAUTHORIZED) {
        loginTimeOut(result);
      }
      return result.json();
    });
  },

  postExcel: (endpoint: string, params: Object) => {
    const options = {
      method: "POST",
      body: JSON.stringify(params),
      responseType: "arrayBuffer",
      headers: {
        ...DEFAULT_HEADERS,
      },
    };

    return fetch(baseUrl + endpoint, options)
      .then((result) => {
        if (result.status === StatusCodes.UNAUTHORIZED) {
          loginTimeOut(result);
        }
        if (result) {
          const a = result.blob().then((res) => {
            const myBlob = new Blob([res], {
              encoding: "UTF-8",
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            });
            FileSaver.saveAs(myBlob, `${params.fileName}.xlsx`);
          });
          return Promise.resolve("success");
        } else {
          return Promise.resolve("fail");
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getExcel: (endpoint: string, params: Object) => {
    const options = {
      method: "GET",
      responseType: "arrayBuffer",
      headers: {
        ...DEFAULT_HEADERS,
      },
    };
    return fetch(
      baseUrl + endpoint + qs.stringify(params.filter, true),
      options
    )
      .then((result) => {
        if (result.status === StatusCodes.UNAUTHORIZED) {
          loginTimeOut(result);
        }
        if (result && result.status === 200) {
          const a = result.blob().then((res) => {
            const myBlob = new Blob([res], {
              encoding: "UTF-8",
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            });
            FileSaver.saveAs(myBlob, `${params.fileName}.xlsx`);
          });
          return Promise.resolve("success");
        } else {
          return Promise.resolve("fail");
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  getPdf: (endpoint: string, params: Object) => {
    const options = {
      method: "GET",
      responseType: "arrayBuffer",
      headers: {
        ...DEFAULT_HEADERS,
      },
    };
    return fetch(
      baseUrl + endpoint + qs.stringify(params.filter, true),
      options
    )
      .then((result) => {
        if (result.status === StatusCodes.UNAUTHORIZED) {
          loginTimeOut(result);
        }
        if (result && result.status === 200) {
          const a = result.blob().then((res) => {
            const myBlob = new Blob([res], {
              encoding: "UTF-8",
              type:
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8",
            });
            FileSaver.saveAs(myBlob, `${params.fileName}.pdf`);
          });
          return Promise.resolve("success");
        } else {
          return Promise.resolve("fail");
        }
      })
      .catch((err) => {
        return Promise.reject(err);
      });
  },

  postImage: (endpoint: string, params: Object) => {
    const formData = new FormData();
    _.forIn(params, (value, key) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });
    const options = {
      method: "POST",
      body: formData,
      headers: {
        Accept: "multipart/form-data",
        "Content-Type": "multipart/form-data",
      },
    };
    return fetch(baseUrl + endpoint, options).then((result) => result.json());
  },

  postRaw: (endpoint: string, params: Object) => {
    const options = {
      method: "POST",
      body: JSON.stringify(params),
      headers: {
        ...DEFAULT_HEADERS,
        "Content-Type": "application/json",
      },
    };
    return fetch(baseUrl + endpoint, options).then((result) => {
      return result.json();
    });
  },

  put: (endpoint: string, params: Object) => {
    const options = {
      method: "PUT",
      body: JSON.stringify(params),
      headers: {
        ...DEFAULT_HEADERS,
        "Content-Type": "application/json",
      },
    };
    return fetch(baseUrl + endpoint, options).then((result) => {
      return result.json();
    });
  },

  delete: (endpoint: string, params: Object) => {
    const options = {
      method: "DELETE",
      body: JSON.stringify(params),
      headers: {
        ...DEFAULT_HEADERS,
        "Content-Type": "application/json",
      },
    };
    return fetch(baseUrl + endpoint, options).then((result) => {
      return result.json();
    });
  },

  postFormData: (endpoint: string, params): Promise => {
    let formData = new FormData();
    _.forIn(params, (value, key) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });
    const options = {
      method: "POST",
      body: formData,
      headers: {
        ...DEFAULT_HEADERS,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    return fetch(baseUrl + endpoint, options).then((result) => {
      if (result.status === StatusCodes.UNAUTHORIZED) {
        loginTimeOut(result);
      }
      return result.json();
    });
  },

  patchFormData: (endpoint: string, params): Promise => {
    let formData = new FormData();
    _.forIn(params, (value, key) => {
      if (value !== null && value !== undefined) {
        formData.append(key, value);
      }
    });

    const options = {
      method: "PATCH",
      body: formData,
      headers: {
        ...DEFAULT_HEADERS,
        Accept: "application/json",
        "Content-Type": "multipart/form-data",
      },
    };

    return fetch(baseUrl + endpoint, options).then((result) => {
      if (result.status === StatusCodes.UNAUTHORIZED) {
        loginTimeOut(result);
      }
      return result.json();
    });
  },

  postUrlFormEncoded: (
    endpoint: string,
    params: Object,
    extraConfig: Object
  ): Promise => {
    const options = {
      method: "POST",
      headers: {
        ...DEFAULT_HEADERS,
        ...extraConfig.headers,
      },
      body: qs.stringify(params),
    };
    return fetch(baseUrl + endpoint, options).then((result) => {
      return result.json();
    });
  },
};
